import type { ReactNode } from 'react';

/** MVP-418: a tone, because status was being carried by `opacity: 0.6` on whole rows — which reads
 * as "disabled", not as "revoked", and is the one signal §2.4 forbids standing alone. Tone changes
 * the TEXT colour only (`--*-text`, the tokens `contrast.test.ts` allows on text); the chip keeps
 * one background so a row of badges still reads as one family. */
export type BadgeTone = 'neutral' | 'ok' | 'danger' | 'info';

export function Badge({ children, tone = 'neutral' }: { children: ReactNode; tone?: BadgeTone }) {
  return <span className={`badge text-meta${tone === 'neutral' ? '' : ` badge--${tone}`}`}>{children}</span>;
}
